import { useTranslation } from 'react-i18next'
import { Check } from 'lucide-react'
import { DropdownMenuItem } from '@/components/ui/dropdown-menu'
import { SUPPORTED_LANGUAGES } from '@/lib/constants'
import { setLanguageChoice } from '@/lib/language'

const LABELS: Record<string, string> = { nb: 'Norsk', en: 'English' }

/**
 * The language options rendered as bare `DropdownMenuItem`s, for embedding
 * inside any `DropdownMenu` — the app topbar's avatar menu (set-once pref) and
 * the standalone `LanguageSwitcher` (public headers) both reuse this so the
 * change-language logic and the checkmark treatment live in ONE place.
 *
 * Pressing an item is the ONE thing in the app that counts as choosing a
 * language, so it goes through `setLanguageChoice` rather than
 * `i18n.changeLanguage` — that is what records the choice and puts it above the
 * event's own language from here on (N-13).
 */
export function LanguageMenuItems() {
  const { i18n } = useTranslation()
  const current = i18n.language?.startsWith('en') ? 'en' : 'nb'
  return (
    <>
      {SUPPORTED_LANGUAGES.map((lng) => (
        <DropdownMenuItem
          key={lng}
          onClick={() => void setLanguageChoice(lng)}
          className="flex items-center justify-between gap-6"
        >
          <span>{LABELS[lng] ?? lng}</span>
          {current === lng && <Check className="size-4 text-[var(--text-link)]" aria-hidden="true" />}
        </DropdownMenuItem>
      ))}
    </>
  )
}
